/* Lastar PDF-motoren først når nokon trykkjer – held hovudbundelen liten */
export const downloadProposalPdf = async (d) => {
  if (typeof window !== "undefined" && !window.Buffer) {
    const { Buffer } = await import("buffer");
    window.Buffer = Buffer;
  }
  const [{ pdf }, { createElement }, { ProductProposalPdf, fileName }] = await Promise.all([import("@react-pdf/renderer"), import("react"), import("./ProductProposalPdf")]);
  const blob = await pdf(createElement(ProductProposalPdf, { d })).toBlob();
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = fileName(d);
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 10000);
};
